import { Maybe, OrgId, UserId } from '@csp/csp-common-model';
import { CriteriaOperatorType, CriteriaType, CriterionV1, QueryV1, SortOrderType } from '@csp/dmdp-api-common-dto';
import { UserCriteriaFieldType, UserIncludeFieldType, UserSortFieldType } from '@csp/dmdp-api-user-dto';
import { UserQueryIn } from './UserQueryIn';

const DEFAULT_FIELDS: UserIncludeFieldType[] = [];

const DEFAULT_SORTING = [
  {
    field: UserSortFieldType.USER_ID,
    order: SortOrderType.DESC,
  },
];

const toUserIdsCriterionV1 = (userIds: Maybe<UserId[]>): Maybe<CriterionV1> => {
  const ids = userIds && userIds.length ? userIds : undefined;
  return ids
    ? {
        fieldCriterion: {
          field: UserCriteriaFieldType.USER_ID,
          type: CriteriaType.IN,
          values: ids,
        },
      }
    : undefined;
};

const toOrgCriterionV1 = (orgIds: Maybe<OrgId[]>): Maybe<CriterionV1> =>
  orgIds?.length
    ? {
        fieldCriterion: {
          field: UserCriteriaFieldType.ACCESS_REF,
          type: CriteriaType.IN,
          values: orgIds,
        },
      }
    : undefined;

const from = ({ criteria: { orgIds, userIds }, fields, sorting }: UserQueryIn): QueryV1 => {
  const rootCriterion: CriterionV1 = {
    operator: CriteriaOperatorType.AND,
    criteria: [],
  };

  const appendCriterion = (criterionV1: Maybe<CriterionV1>): void => {
    if (criterionV1) {
      rootCriterion.criteria?.push(criterionV1);
    }
  };

  appendCriterion(toOrgCriterionV1(orgIds));
  appendCriterion(toUserIdsCriterionV1(userIds));

  return {
    fields,
    criterion: rootCriterion,
    sort: sorting,
  };
};

export const UserQuery = {
  from,
  defaultFields: DEFAULT_FIELDS,
  defaultSorting: DEFAULT_SORTING,
};
